// src/components/FeedbackButton.js
import React, { useState } from 'react';
import { enviarFeedback } from '../services/api';
import { useAuth } from '../context/AuthContext';

const FeedbackButton = () => {
  const { user } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
	  titulo: '',
	  descripcion: '',
	  tipo: 'general',
	  url: ''  // ← Inicialmente vacío
	});
	
  // Al abrir el modal, actualizar la URL
	const abrirModal = () => {
	  setFormData(prev => ({
		...prev,
		url: window.location.href  // ← Captura la URL actual en el momento de abrir
	  }));
	  setShowModal(true);
	};

  const [enviando, setEnviando] = useState(false);
  const [mensaje, setMensaje] = useState({ type: '', text: '' });

  // Solo mostrar para usuarios autenticados (beta testers y admins)
  if (!user) return null;

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEnviando(true);
    setMensaje({ type: '', text: '' });

    try {
      await enviarFeedback(formData);
      setMensaje({ 
        type: 'success', 
        text: '✅ ¡Gracias por tu feedback! Ayudas a mejorar KREAMUN.' 
      });
      setTimeout(() => {
        setShowModal(false);
        setMensaje({ type: '', text: '' });
        setFormData({
          titulo: '',
          descripcion: '',
          tipo: 'general',
          url: window.location.href
        });
      }, 2000);
    } catch (error) {
      setMensaje({ 
        type: 'error', 
        text: '❌ Error al enviar feedback. Intenta de nuevo.' 
      });
    } finally {
      setEnviando(false);
    }
  };

  return (
    <>
      {/* Botón flotante */}
      <button 
		  className="feedback-floating-btn"
		  onClick={abrirModal}  // ← Cambiado
		  title="Reportar problema o sugerencia"
		>
		  💬
		</button>

      {/* Modal de feedback */}
      {showModal && (
        <div className="feedback-modal-overlay">
          <div className="feedback-modal">
            <div className="feedback-modal-header">
              <h3>📢 Ayúdanos a mejorar KREAMUN</h3>
              <button 
                className="feedback-close"
                onClick={() => setShowModal(false)}
              >
                ×
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Tipo de feedback:</label>
                <select 
                  name="tipo" 
                  value={formData.tipo} 
                  onChange={handleChange}
                  required
                >
                  <option value="general">💬 Comentario general</option>
                  <option value="bug">🐛 Reportar un error</option>
                  <option value="sugerencia">💡 Sugerencia</option>
                  <option value="mejora">✨ Idea de mejora</option>
                </select>
              </div>

              <div className="form-group">
                <label>Título (resume tu feedback):</label>
                <input
                  type="text"
                  name="titulo"
                  value={formData.titulo}
                  onChange={handleChange}
                  placeholder="Ej: Error al generar imagen, No puedo continuar historia..."
                  required
                  maxLength="100"
                />
              </div>

              <div className="form-group">
                <label>Descripción detallada:</label>
                <textarea
                  name="descripcion"
                  value={formData.descripcion}
                  onChange={handleChange}
                  placeholder="¿Qué pasó? ¿Qué esperabas que pasara? (Incluye pasos para reproducir el error si es posible)"
                  rows="5"
                  required
                />
              </div>

              <div className="form-group">
                <label>URL actual:</label>
                <input
                  type="text"
                  name="url"
                  value={formData.url}
                  onChange={handleChange}
                  readOnly
                  className="url-disabled"
                />
                <small>Esta información ayuda a localizar el problema</small>
              </div>

              {mensaje.text && (
                <div className={`feedback-mensaje ${mensaje.type}`}>
                  {mensaje.text}
                </div>
              )}

              <div className="feedback-modal-footer">
                <button 
                  type="button" 
                  onClick={() => setShowModal(false)}
                  className="btn-cancelar"
                  disabled={enviando}
                >
                  Cancelar
                </button>
                <button 
                  type="submit" 
                  className="btn-enviar"
                  disabled={enviando}
                >
                  {enviando ? 'Enviando...' : 'Enviar feedback'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default FeedbackButton;